import { FilterDocument, FilterOptionKeys, TaskType } from '@griply/types';

export const isShowingHabits = (filterDocument: FilterDocument): boolean => {
  const typeInclude = filterDocument.filters?.[FilterOptionKeys.Type]?.include;
  return !typeInclude || typeInclude.includes(TaskType.Habit);
};
